export default __webpack_public_path__ + "static/media/video-sequences.584fc884.svg";